import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faCog,
    faHashtag,
    faFlagCheckered,
    faCalendarAlt,
    faMapMarkerAlt,
    faAddressBook, faBoxes, faBox, faBook, faHardHat, faTruck, faDownload, faEdit, faCoins, faTruckMoving,
} from '@fortawesome/free-solid-svg-icons'
import {toast} from "react-toastify";
import {MapContainer, TileLayer, Marker} from 'react-leaflet'
import L from 'leaflet';
import "leaflet/dist/leaflet.css"

import UserMarker from '../../assets/images/user-pos.png';
import Loading from "../Common/Loading";

const currencyFormat = Intl.NumberFormat('en-US');

let DefaultIcon = L.icon({
    iconUrl: UserMarker,
    iconSize: [16,16],

});

L.Marker.prototype.options.icon = DefaultIcon;
class Request extends Component {
    state = {
        request: {
            status: [],
            company: [],
            loading_addresses: [],
            unloading_addresses: [],
            consignments: [],
            documents: [],
            isLoaded :false,
            history :[],
            suggested_price : '',
            callDisable : false
        },
        expert_description : '',
        description:''
    }
    findRoute = (lat, lng) => {
        /* const currentLat = window.localStorage.getItem("d-lat");
         const currentLng = window.localStorage.getItem("d-lng");
      /* if (!currentLat || !currentLng) {
             toast.warning('موقعیت شما پیدا نشد لطفا لوکیشن خود را روشن کرده و دسترسی آن را به اپلیکیشن بدهید');
             return false;
         }*/
        const url = "http://maps.google.com/maps?saddr="
             + "&daddr="
            + lat + "," + lng
        window.open(url)
    }
    finishRequest = () => {
        API.finishRequest(this.props.match.params.id)
            .then((response) => {
                API.request(this.props.match.params.id)
                    .then((response) => {
                        const request = response.results.request;
                        this.setState({request})
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    calDriver = (driver_id) => {
        this.setState({callDisable : true})
        API.callDriverPosition(driver_id)
            .then((response) => {
                toast.success(response.user_message);
            })
            .catch((error) => {
                this.setState({callDisable : false})
                toast.error(error.response.data.user_message);
            });
    }
    onVerifyClick = () => {
        const request = {
            status_id : 2 ,
            expert_description : this.state.expert_description ,
            request_id : this.props.match.params.id,

        }
        API.setStatus(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                },1200)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    UpdateDescription = () => {
        const request = {
            description : this.state.description ,
            id : this.props.match.params.id,

        }
        API.setDescription(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                },1200)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }

    UpdatePrice = () => {
        const request = {
            suggested_price : this.state.request.suggested_price ,
            id : this.props.match.params.id,

        }
        API.setPrice(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                },1200)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onUnloadingClick = () => {
        const request = {
            status_id : 7 ,
           // expert_description : this.state.expert_description ,
            request_id : this.props.match.params.id,

        }
        API.setStatus(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                },1200)
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
                toast.error(error.response.data.user_message);

            });
    }
    onEditClick = () => {
        if(this.state.expert_description.length < 10) {
            toast.error('ابتدا توضیحات مربوطه و مواردی که باید اصلاح شود را در قسمت توضیحات وارد نمایید');
            return false
        }
        const request = {
            status_id : 11 ,
            expert_description : this.state.expert_description ,
            request_id : this.props.match.params.id,

        }
        API.setStatus(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                },1200)
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
    render() {
        let hasLocation = 0;
        if (typeof (this.state.request.driver) !== 'undefined') {
            if (typeof (this.state.request.driver.location) !== 'undefined') {
                hasLocation = Object.keys(this.state.request.driver.location).length;
            }
        }
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='پروفایل درخواست'/>
                <section className="container mt-4 rtl py-5 mb-5">
                    <div className="row px-2 border-bottom pb-2">
                        <div className="col-1 ">
                            <FontAwesomeIcon icon={faHashtag} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            کد پیگیری
                        </div>
                        <div className="col-7 text-left fw-bold text-primary">
                            {this.state.request.tracking_code}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCog} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            وضعیت درخواست
                        </div>
                        <div className="col-7 text-left fw-bold super-small"
                             style={{color: this.state.request.status.color}}>
                            {this.state.request.status.title}
                        </div>


                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faFlagCheckered} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            نام شرکت
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.company.title}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            تاریخ بارگیری
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.loading_date}
                            &nbsp;
                            -
                            &nbsp;
                            {this.state.request.loading_time}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            تاریخ تخلیه
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.unloading_date}
                            &nbsp;
                            -
                            &nbsp;
                            {this.state.request.unloading_time}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faTruck} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                           نوع خودروی درخواستی
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.car_type ? this.state.request.car_type.parent : ''}
                            &nbsp;
                            -
                            &nbsp;
                            {this.state.request.car_type ? this.state.request.car_type.title : ''}


                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            بارنامه
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.waybill ?
                                <a href={this.state.request.waybill} target='_blank' rel="noreferrer"> دانلود بارنامه</a> :
                                <span>هنوز الحاق نشده است</span>
                            }

                        </div>
                    </div>
                    {(this.state.request.driver && Object.keys(this.state.request.driver).length > 0) ?
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faHardHat} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            راننده
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                                   {this.state.request.driver.first_name}
                                    &nbsp;
                                    {this.state.request.driver.last_name}

                        </div>
                        <div
                            className="col-12  super-small text-left mt-2 border-bottom mb-3 ">
                            شماره تماس:
                            &nbsp;
                            <a href={"tel:" + this.state.request.driver.mobile}>
                                {this.state.request.driver.mobile}
                            </a>

                        </div>

                        <div className='col-6 super-small text-end'>
                            آخرین دریافت :
                            &nbsp;
                            {
                                this.state.request.driver?.location?.last_send
                            }
                        </div>
                        <div className='col-6 super-small text-start'>
حدود
                            {
                                Math.round( this.state.request.driver?.location?.diff_send_hour)

                            }
                            &nbsp;
                            ساعت پیش
                        </div>
                        <div className="col-12 mt-2 pt-2">

                            {hasLocation  ?
                                <MapContainer
                                    center={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                    zoom={13}
                                    scrollWheelZoom={true}
                                    className="driver-map px-2 rounded-more"
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://idmt.ir">IDMT</a> '
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker
                                        position={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                    />
                                </MapContainer> : ''}
                        </div>

                    </div> :

                   <div className="row">
                       <div className="col-12 py-2">
                           <button className='btn btn-outline-primary w-100 super-small'
                           onClick={() => {this.props.history.push('/select-driver/'+ this.state.request.id)}}
                           >
                               تخصیص راننده به درخواست
                           </button>
                       </div>
                   </div>

                    }
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faTruckMoving} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            صافی راننده
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {currencyFormat.format(this.state.request.driver_share)}
                            &nbsp;
                            ریال
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCoins} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            بیمه (ارزش بار)
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {currencyFormat.format(this.state.request.load_value)}
                            &nbsp;
                            ریال
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faAddressBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            آدرس های بارگیری
                        </div>

                        {
                            this.state.request.loading_addresses.map(address => {
                                return (
                                    <div className="row mt-3" key={address.id}>
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className='text-secondary small'/>
                                        </div>
                                        <div className="col-10 small line-height-2">
                                            <b>{address.title}</b>
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.address}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.contact_name}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            <a href={'tel:' + address.contact_number}> {address.contact_number}</a>

                                        </div>

                                    </div>
                                )
                            })
                        }

                    </div>
                    <div className="row px-2  mt-4  pb-2 border-bottom">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faAddressBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            آدرس های تخلیه
                        </div>

                        {
                            this.state.request.unloading_addresses.map(address => {
                                return (
                                    <div className="row mt-3" key={address.id}>
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className='text-secondary small'/>
                                        </div>
                                        <div className="col-10 small line-height-2">
                                            <b>{address.title}</b>
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.address}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.contact_name}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            <a href={'tel:' + address.contact_number}> {address.contact_number}</a>

                                        </div>

                                    </div>
                                )
                            })
                        }

                    </div>

                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faEdit} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            توضیحات درخواست:
                        </div>
                        <div className="col-7 text-right fw-bold super-small rtl">
                            {this.state.request.description}
                        </div>

                    </div>
                    {
                        this.state.request.small_cargo ?
                            <div className="row px-2  mt-4 border-bottom pb-2">
                                <div className="col-1">
                                    <FontAwesomeIcon icon={faCoins} className='text-secondary small'/>
                                </div>
                                <div className="col-4 text-right super-small text-secondary">
                                    نرخ توافقی (ریال):
                                </div>
                                <div className="col-7 text-center fw-bold super-small rtl">
                                    <div className="mb-3 ">
                                        <input type="number" className="form-control w-100" id="floatingInput"
                                               value={this.state.request.suggested_price}
                                               onChange={
                                                   (val) => {
                                                       var request = {...this.state.request}
                                                       request.suggested_price = val.target.value;
                                                       this.setState({request})
                                                   }
                                               }
                                        />
                                        <br/>
                                        <strong className="rtl">
                                            {this.state.request.suggested_price.length > 0 && currencyFormat.format(this.state.request.suggested_price)}
                                            <span>
                                                            &nbsp;
                                                ریال
                                                        </span>
                                        </strong>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button className='btn btn-outline-primary mt-2 w-100' onClick={this.UpdatePrice}>
                                        ثبت نرخ توافقی
                                    </button>
                                </div>
                            </div>
                            : ''
                    }

                    <div className="row mt-4 bg-light py-3">
                        <div className="col-12 text-right super-small text-secondary">
                           فایل های الحاقی
                        </div>
                        <div
                            className='row text-center py-3 m-auto mt-2 transactions-header  '>
                            <div className="col-3">عنوان</div>
                            <div className="col-6">توضیحات</div>
                            <div className="col-3">دانلود</div>

                        </div>
                        {
                            this.state.request.documents.map(doc => {

                                return (
                                    <div
                                        className='row text-center text-dark py-3 m-auto mt-2 transactions-body  '
                                        key={doc.id}>
                                        <div className="col-3 fw-bold">
                                            {doc.title? doc.title.replace('-CFD0-' , '') : ''}
                                        </div>
                                        <div
                                            className="col-6 super-small"> {doc.description}
                                            {
                                                doc.title?
                                                    doc.title.indexOf('-CFD0-') === -1 &&
                                                    <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                                    :  <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                            }
                                        </div>
                                        <div className="col-3 small">
                                            <a href={doc.path} target="_blank"
                                               rel="noreferrer">
                                                <FontAwesomeIcon
                                                    icon={faDownload}/>&nbsp;
                                                دانلود
                                            </a>
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="row px-2  mt-4 border-bottom pb-5 mb-5">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faBoxes} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            محموله ها
                        </div>

                        {
                            this.state.request.consignments.map(cons => {
                                return (
                                    <div className="row mt-3" key={cons.id}>
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faBox} className='text-secondary super-small'/>
                                        </div>
                                        <div className="col-8 small line-height-2">
                                            {cons.title}


                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                    <div className="row text-center history-head small">
                        <div className="col-6 ">
                            وضعیت
                        </div>
                        <div className="col-6 ">
                            زمان
                        </div>

                    </div>
                    {
                        this.state.request.history.map(hist => {
                            return (
                                <div className="row text-center history-row small">
                                    <div className="col-6 ">
                                        {hist.status}
                                    </div>
                                    <div className="col-6">
                                        {hist.date}
                                    </div>
                                </div>
                            )

                        })

                    }
                </section>
                {this.state.request.status.id === 1 ?
                <section className='container-fluid fixed-bottom max-w-lg bg-light-dark rtl p-4 '>
                    <div className="row">
                        <div className="col-12">
                            <textarea className='w-100 small text-center p-2 rounded' placeholder='در صورتی که درخواست نیاز به اصلاح دارد توضیحات خود را بنویسید'
                            onChange={(val) => {this.setState({expert_description : val.target.value})} }
                            ></textarea>
                        </div>
                        <div className="col-7">
                            <button className='btn btn-success w-100'
                            onClick={this.onVerifyClick}
                            >تایید درخواست</button>
                        </div>
                        <div className="col-5">
                            <button className='btn btn-secondary w-100 small'
                                    onClick={this.onEditClick}
                            >نیاز به اصلاح</button>
                        </div>
                    </div>
                </section> : '' }


            </React.Fragment>
        );
    }

    componentDidMount() {
        API.request(this.props.match.params.id)
            .then((response) => {
                const request = response.results.request;
                this.setState({request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })

    }
}

export default Request;